import React from 'react'

import styles from './Checkbox.module.scss'
import classNames from 'classnames/bind'

type Props = {
  dark?: boolean
  small?: boolean
}

const cx = classNames.bind(styles)

export const CheckBox = ({
  title,
  children,
  dark,
  small,
  ...rest
}: Props & React.InputHTMLAttributes<HTMLInputElement>): JSX.Element => {
  const _classes = cx('checkbox', {
    checked: rest.checked,
    dark,
    small,
  })

  return (
    <div
      role="checkbox"
      aria-checked={rest.checked}
      aria-hidden="true"
      className={_classes}
      id={rest.id}
      onClick={rest.onClick}
      onChange={rest?.onChange}
    >
      <input className={styles.checkbox__control} {...rest} type="checkbox" />
      <label htmlFor={rest.id}>{title}</label>
      <div className={styles['children-container']}>{children}</div>
    </div>
  )
}
